(ns common.schema.entities.fundraising-opportunity.schema
  (:require
   [common.country :as country]
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common-schema]
   [common.schema.constraints :as constraints]
   [common.schema.option-filters :as option-filters]
   [common.status :as statuses]))

(def import-fixed-fields
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/investor
   :fundraising-opportunity/pipeline
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/status
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/cur-commitment-amount--sym])

(def schema
  (vec
   (concat
    (su/text-simple-field
     :fundraising-opportunity/opportunity-name
     "Name"
     {:name-attribute           :fundraising-opportunity/opportunity-name
      :lower-case-str?          true
      :not-clearable?           true
      :mandatory-config         :mandatory/always
      :system-semantics         su/user-provided-system-required-field-semantics
      :system-required?         true
      :editor-type              :editor.type/none
      :default-field-visibility :in-use-disabled
      :constraints              {:constraint/string-min-length         1
                                 :constraint/unique-tenant-ignore-case
                                 {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                          :fundraising-opportunity/opportunity-name
                                                          [:entity.type/fundraising-opportunity])}}})
    (su/single-ref-field :fundraising-opportunity/pipeline
                         "Pipeline"
                         [:entity.type/pipeline]
                         {:not-clearable?           true
                          :option-filter-fn         (partial option-filters/pipelines
                                                             :entity.type/fundraising-opportunity)
                          :mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled
                          :authorization            {:access/read  :role/guest-buy-side
                                                     :access/write :role/user}})
    (su/single-ref-field :fundraising-opportunity/fund
                         "Our fund"
                         [:entity.type/fund]
                         {:create-visibility        :create.visibility/optional
                          :option-filter-fn         option-filters/pipeline-funds
                          :field-in-use-filter      su/fund-field-in-use?
                          :default-field-visibility :in-use})
    (su/single-ref-field :fundraising-opportunity/investor
                         "Investor"
                         [:entity.type/investor]
                         {:create-on-fly?           true
                          :deep-indexing?           true
                          :select-entity-types      [:entity.type/person :entity.type/company]
                          :create-entity-types      [:entity.type/person :entity.type/company]
                          :editor-type              :editor.type/none
                          :grid-type                :editor.type/link
                          :filter                   :filter.type/select
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :fundraising-opportunity/owner
                         "Owner"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :system-semantics         su/system-prefilled-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :mandatory-config         :mandatory/always
                          :create-visibility        :create.visibility/optional
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :fundraising-opportunity/credit
                         "Credit"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :create-visibility        :create.visibility/optional
                          :default-field-visibility :in-use})
    (su/percentage-field :fundraising-opportunity/probability-percentage
                         "Probability %"
                         {:create-visibility        :create.visibility/optional
                          :default-field-visibility :not-in-use})
    (su/option-field :fundraising-opportunity/probability-category
                     "Probability"
                     {:default-field-visibility :in-use})
    (su/option-field :fundraising-opportunity/target-closing
                     "Target closing"
                     {:create-visibility        :create.visibility/optional
                      :default-field-visibility :in-use})
    (su/option-field :fundraising-opportunity/closing-stage
                     "Closing stage"
                     {:default-field-visibility :in-use})
    (su/currency-field :fundraising-opportunity/cur-commitment-amount
                       "Expected commitment amount"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :in-use-disabled})
    (su/currency-field :fundraising-opportunity/cur-min-commitment-amount
                       "Min commitment amount"
                       {:default-field-visibility :in-use})
    (su/currency-field :fundraising-opportunity/cur-max-commitment-amount
                       "Max commitment amount"
                       {:default-field-visibility :in-use})
    (su/text-multiline-field :fundraising-opportunity/description
                             "Description"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use})
    (su/text-multiline-field :fundraising-opportunity/next-steps
                             "Next steps"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use})
    (su/text-multiline-field :fundraising-opportunity/overview
                             "Overview"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use-disabled})
    [[:fundraising-opportunity/status
      {:field/data-type :data.type/keyword
       :value-type :keyword
       :field/mandatory :mandatory/always
       :field/system-semantics su/user-provided-system-required-field-semantics
       :field/system-required? true
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/not-clearable? true
       :field/not-shown-in-create? true
       :field/translations {:en "Status"}
       :options statuses/fundraising-opportunity-status-options}]
     common-schema/team-members-field
     common-schema/common-network-drive-field]
    common-schema/common-network-drives-field
    common-schema/common-folders-path

    (su/datetime-field :fundraising-opportunity/on-hold-until
                       "On hold until"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics
                        :authorization     su/access-system-user})
    (su/datetime-field :fundraising-opportunity/won-on
                       "Won on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics
                        :authorization     su/access-system-user})
    (su/datetime-field :fundraising-opportunity/lost-on
                       "Lost on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics
                        :authorization     su/access-system-user})
    (su/datetime-field :fundraising-opportunity/put-on-hold-on
                       "Put on hold on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics
                        :authorization     su/access-system-user})
    (su/text-multiline-field :fundraising-opportunity/on-hold-comment
                             "Last on hold comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none
                              :system-semantics  su/system-controlled-optional-field-semantics
                              :authorization     su/access-system-user})
    (su/option-field :fundraising-opportunity/lost-reason
                     "Lost reason"
                     {:default-field-visibility :in-use-disabled
                      :create-visibility :create.visibility/optional
                      :editor-type   :editor.type/none
                      :grid          :editor.type/select
                      :system-semantics su/system-controlled-optional-field-semantics
                      :authorization su/access-system-user})
    (su/text-multiline-field :fundraising-opportunity/lost-comment
                             "Lost comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none
                              :grid-type         :editor.type/none
                              :authorization     su/access-system-user})
    (su/single-ref-field :fundraising-opportunity/opportunity-stage
                         "Stage"
                         [:entity.type/opportunity-stage]
                         {:mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :option-filter-fn         option-filters/opportunity-stages-in-pipeline
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled})
    (su/boolean-field :fundraising-opportunity/needs-feeder-fund?
                      "Needs feeder fund?"
                      {:default-field-visibility :in-use})
    (su/boolean-field :fundraising-opportunity/interested-in-co-investment?
                      "Interested in co-investment?"
                      {:create-visibility        :create.visibility/optional
                       :default-field-visibility :not-in-use})
    (su/datetime-field :fundraising-opportunity/datetime-expected-decision
                       "Expected decision"
                       {:create-visibility :create.visibility/optional
                        :editor-type       :editor.type/datetime
                        :grid-type         :editor.type/datetime
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use})
    (su/boolean-field :fundraising-opportunity/eu-entity?
                      "EU entity"
                      {:create-visibility        :create.visibility/optional
                       :default-field-visibility :not-in-use-blocked})
    (su/keyword-multi-field :fundraising-opportunity/country
                            "Country"
                            country/options
                            {:create-visibility        :create.visibility/optional
                             :default-field-visibility :not-in-use-blocked})
    (su/boolean-field :fundraising-opportunity/interest-in-current-round?
                      "Interest in current round"
                      {:create-visibility        :create.visibility/optional
                       :default-field-visibility :not-in-use-blocked})
    (su/boolean-field :fundraising-opportunity/interest-after-current-round?
                      "Interest after current round"
                      {:create-visibility        :create.visibility/optional
                       :default-field-visibility :not-in-use-blocked})
    (su/boolean-field :fundraising-opportunity/agent-confirmed-no-conflict?
                      "Agent confirmed no conflict"
                      {:create-visibility        :create.visibility/optional
                       :default-field-visibility :not-in-use-blocked})
    (su/currency-field :fundraising-opportunity/cur-soft-commitment-amount
                       "Soft commitment amount"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :not-in-use})
    (su/currency-field :fundraising-opportunity/cur-hard-commitment-amount
                       "Hard commitment amount"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :not-in-use})
    (su/currency-field :fundraising-opportunity/cur-additional-potential-amount
                       "Additional potential amount"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :not-in-use})
    (su/date-field :fundraising-opportunity/date-first-contact
                   "First contact"
                   {:default-field-visibility :not-in-use-blocked
                    :create-visibility :create.visibility/optional
                    :authorization     su/access-user-user})
    (su/date-field :fundraising-opportunity/date-first-meeting
                   "First meeting"
                   {:default-field-visibility :not-in-use-blocked
                    :create-visibility :create.visibility/optional
                    :authorization     su/access-user-user})
    (su/date-field :fundraising-opportunity/date-latest-meeting
                   "Latest meeting"
                   {:default-field-visibility :not-in-use-blocked
                    :create-visibility :create.visibility/optional
                    :authorization     su/access-user-user})
    (su/option-field-multi :fundraising-opportunity/internal-contact
                           "Internal contact"
                           {:create-visibility        :create.visibility/optional
                            :default-field-visibility :not-in-use-blocked})
    (su/option-field-multi :fundraising-opportunity/tag-tags
                           "Tags"
                           {:create-visibility        :create.visibility/optional
                            :default-field-visibility :in-use})
    (su/single-ref-field :fundraising-opportunity/fund-commitment
                         "Commitment"
                         [:entity.type/fund-commitment]
                         {:editor-type          :editor.type/link
                          :grid-type            :editor.type/link
                          :default-field-visibility :in-use
                          :not-shown-in-create? true
                          :authorization        su/access-user-user})
    (su/integer-field :fundraising-opportunity/priority
                      "Priority"
                      {:default-field-visibility :not-in-use})
    (su/text-edn-field :fundraising-opportunity/ratings
                       "Ratings"
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
    (su/option-field-multi :fundraising-opportunity/tag-type "Type" {})

    (su/integer-field :fundraising-opportunity/number-of-times-contacted
                      "Number of Times Contacted"
                      {:default-visibility :not-in-use})
    (su/option-field :fundraising-opportunity/source "Source" {:default-visibility :not-in-use})
    (su/datetime-field :fundraising-opportunity/create-date
                       "Create Date"
                       {:default-visibility :not-in-use})

    (su/datetime-field :fundraising-opportunity/reactivated-on
                       "Reactivated on"
                       {:default-visibility :in-use-disabled
                        :editor-type        :editor.type/none
                        :system-semantics   su/system-controlled-optional-field-semantics
                        :authorization      su/access-system-user})
    (su/single-ref-field :fundraising-opportunity/reactivated-by
                         "Reactivated by"
                         [:entity.type/account]
                         {:default-visibility :in-use-disabled
                          :system-semantics   su/system-controlled-optional-field-semantics
                          :authorization      su/access-system-user}))))
